import { skipToken, useQuery } from '@tanstack/react-query'

import { AGENT_PERMISSIONS } from '@/lib/permissions'
import { usePermissions } from '@/lib/use-permissions'

import { assetsApi, type PrinterCounterKind } from '../../api/assets-api'
import { assetKeys } from '../../api/query-keys'

const PRINTER_COUNTER_KINDS_STALE_MS = 5 * 60_000

export function useCanReadPrinterCounterKinds() {
  return usePermissions().can(AGENT_PERMISSIONS.read)
}

export function usePrinterCounterKinds(entityId: string | null) {
  const canRead = useCanReadPrinterCounterKinds()
  const queryKey = assetKeys.printerCounterKinds(entityId ?? '')
  return useQuery<PrinterCounterKind[]>({
    queryKey: canRead ? queryKey : [...queryKey, 'disabled'],
    queryFn:
      canRead && entityId !== null ? () => assetsApi.getPrinterCounterKinds(entityId) : skipToken,
    staleTime: PRINTER_COUNTER_KINDS_STALE_MS,
  })
}
